/**
 * Wraps a list of event handlers returning a single handler that allows a
 * handler to stop next handler excecution. Allows for user to prevent
 * lib-defined handlers from firing.
 *
 * @param handlers A list of user-supplied and lib-defined event handlers
 */
export function composeEventHandlers() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }
  return function handleEvent(evt) {
    handlers.some(function (fn) {
      fn === null || fn === void 0 || fn(evt);
      return evt.defaultPrevented;
    });
  };
}